/**
 * This is an identity function that just allows to specify type for literal
 * being passed as parameter, similar to createStyle from material-ui
 */
export function literalAs<T>(value: T) {
	return value;
}
